var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ApiProvider } from "@context/api";
import { UIProvider, useUI } from "@context/ui";
import { StoreProvider } from "@context/store";
import { Form } from "@components/form";
import { AddToCart } from "@components/add-to-cart";
import { Recharge } from "./recharge";
import { useConfig } from "@context/config";
import { useEffect, useState } from "react";
import { useDeliveryDoorstep, useDeliveryPickup } from "@hooks/api";
import { SHIPPING_PLACE, SHIPPING_TYPE, SHIPPING_SLOT } from "@constants/index";
import { DeliveryType } from "@schema/types";
var PruductPageApp = function () {
    return (_jsxs(StoreProvider, { children: [_jsx(Form, {}, void 0),
            _jsx(AddToCart, {}, void 0)] }, void 0));
};
var RechargeApp = function () {
    var _a = useState({}), initial = _a[0], setInitial = _a[1];
    var _b = useState(false), loaded = _b[0], setLoaded = _b[1];
    var recharge = useConfig().recharge;
    var setStep = useUI().setStep;
    var _c = useDeliveryDoorstep(), getDeliveryDoorstep = _c[0], _d = _c[1], doorstepData = _d.data, doorstepLoading = _d.loading, doorstepError = _d.error;
    var _e = useDeliveryPickup(), getDeliveryPickup = _e[0], _f = _e[1], pickupData = _f.data, pickupLoading = _f.loading, pickupError = _f.error;
    useEffect(function () {
        if (recharge) {
            var _a = recharge, _b = _a.properties, _c = SHIPPING_PLACE, place = _b[_c], _d = SHIPPING_TYPE, deliveryType = _b[_d], _e = SHIPPING_SLOT, slot = _b[_e];
            if (deliveryType === DeliveryType.Pickup) {
                getDeliveryPickup({ id: place });
            }
            else {
                getDeliveryDoorstep({ timeEntryId: slot });
            }
        }
    }, []);
    useEffect(function () {
        var findSelectedSlot = function (slots, id) {
            for (var _i = 0, slots_1 = slots; _i < slots_1.length; _i++) {
                var _a = slots_1[_i], timeEntries = _a.timeEntries, date = _a.date;
                var timeEntry = timeEntries.find(function (timeEntry) { return timeEntry.id === id; });
                if (timeEntry) {
                    return {
                        timeEntry: timeEntry,
                    };
                }
            }
            return {};
        };
        var getSelectedTimeEntry = function (slots, id) {
            var slot = findSelectedSlot(slots, id);
            if (slot && slot.timeEntry) {
                var _a = slot.timeEntry, id_1 = _a.id, startTime = _a.startTime, endTime = _a.endTime, variantId = _a.variantId;
                return {
                    id: id_1,
                    startTime: startTime,
                    endTime: endTime,
                    variantId: variantId,
                };
            }
        };
        var select = function () {
            if (!recharge) {
                throw "`recharge` property is missing.";
            }
            var _a = recharge, _b = _a.properties, _c = SHIPPING_PLACE, place = _b[_c], _d = SHIPPING_TYPE, deliveryType = _b[_d], _e = SHIPPING_SLOT, slot = _b[_e], address = _a.address, nextChargeScheduledAt = _a.nextChargeScheduledAt;
            if (pickupData) {
                var location_1 = pickupData.find(function (_a) {
                    var id = _a.id;
                    return id === place;
                });
                if (!location_1) {
                    throw "Unable to find selected location.";
                }
                var id = location_1.id, price = location_1.price, slots = location_1.slots, name_1 = location_1.name;
                var timeEntry = getSelectedTimeEntry(slots, slot);
                if (!timeEntry) {
                    throw "Unable to find selected timeEntry.";
                }
                setStep(3);
                setInitial({
                    type: deliveryType,
                    location: {
                        id: id,
                        price: price,
                        slots: slots,
                        name: name_1,
                        address: location_1.address,
                    },
                    address: address,
                    timeEntry: __assign(__assign({}, timeEntry), { date: new Date(nextChargeScheduledAt) }),
                });
                return;
            }
            if (doorstepData) {
                var location_2 = doorstepData.find(function (_a) {
                    var id = _a.id;
                    return id === place;
                });
                if (!location_2) {
                    throw "Unable to find selected location.";
                }
                var id = location_2.id, price = location_2.price, slots = location_2.slots, zipCode = location_2.zipCode;
                var timeEntry = getSelectedTimeEntry(slots, slot);
                if (!timeEntry) {
                    throw "Unable to find selected timeEntry.";
                }
                setStep(3);
                setInitial({
                    type: deliveryType,
                    location: { id: id, price: price, slots: slots, zipCode: zipCode },
                    address: address,
                    timeEntry: __assign(__assign({}, timeEntry), { date: new Date(nextChargeScheduledAt) }),
                });
                return;
            }
        };
        try {
            select();
        }
        catch (error) {
            console.error("dapp: " + error);
            setLoaded(true);
        }
    }, [pickupData, doorstepData]);
    if (!initial.type && !loaded) {
        return (_jsxs("div", __assign({ className: "animate-pulse opacity-40 space-y-2 px-6 py-4" }, { children: [_jsx("div", { className: "h-4 bg-decent rounded w-3/5" }, void 0),
                _jsx("div", { className: "h-4 bg-decent rounded w-4/5" }, void 0)] }), void 0));
    }
    return (_jsxs(StoreProvider, __assign({ initial: initial }, { children: [_jsx(Form, { initialized: true }, void 0),
            _jsx(Recharge, {}, void 0)] }), void 0));
};
var App = function (props) {
    var variantSelectorId = useConfig().variantSelectorId;
    return (_jsx(ApiProvider, { children: _jsx(UIProvider, { children: _jsx("div", __assign({ className: "font-sans text-base" }, { children: variantSelectorId ? (_jsx(PruductPageApp, __assign({}, props), void 0)) : (_jsx(RechargeApp, __assign({}, props), void 0)) }), void 0) }, void 0) }, void 0));
};
export default App;
